import { render, staticRenderFns } from "./AddSales.vue?vue&type=template&id=1b1626ec&scoped=true&"
import script from "./AddSales.vue?vue&type=script&lang=js&"
export * from "./AddSales.vue?vue&type=script&lang=js&"
import style0 from "./AddSales.vue?vue&type=style&index=0&id=1b1626ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1626ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b1626ec')) {
      api.createRecord('1b1626ec', component.options)
    } else {
      api.reload('1b1626ec', component.options)
    }
    module.hot.accept("./AddSales.vue?vue&type=template&id=1b1626ec&scoped=true&", function () {
      api.rerender('1b1626ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/SalesPromotion/modules/AddSales.vue"
export default component.exports